import { CatalogueModel, InviteInfo, PlaybackThridParty } from './model';
import http from '/@/api/fetch';

const API = {
  getCourseCatalogue: '/course-web/client/v1/course/catalogue',
  getLinksInviteId: '/contents-web/v1/live/links/enter-room',
  getLinksVideoThridPartyId: '/contents-web/v1/video/links/query-third-party-id/by-resource',
  getLinksPlaybackThridPartyId: '/contents-web/v1/playback/links/query-third-party-id/by-resource',
  getInviteInfoByShortLink: '/course-web/client/v1/invite-links/get-invite-info/by-short-link',
};

/**
 * 课程目录
 */
export const getCourseCatalogue = (params: { termId: string }) =>
  http.get<CatalogueModel>(API.getCourseCatalogue, params);

/**
 * 获取灵狮直播的邀课ID
 */
export const getLinksInviteId = (params: { resourceId: string; inviteLinkId?: string }) =>
  http.get<{ lessonId: string; videoIsDel?: string }>(API.getLinksInviteId, params);

/**
 * 通过资源id获取灵狮视频的第三方视频id
 */
export const getLinksVideoThridPartyId = (params: { resourceId: string }) =>
  http.get<{ thirdPartyId: string; videoIsDel: string }>(API.getLinksVideoThridPartyId, params);

/**
 * 取灵狮回放的第三方视频id
 */
export const getLinksPlaybackThridPartyId = (params: { resourceId: string }) =>
  http.get<PlaybackThridParty>(API.getLinksPlaybackThridPartyId, params);

export const getInviteInfoByShortLink = (params: { shortLink: string }) =>
  http.get<InviteInfo>(API.getInviteInfoByShortLink, params, { message: false });
